var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section-post-creator" }, [
    _c("header", [
      _c("div", { staticClass: "container-title" }, [
        _c("div", {
          staticClass: "btn-back",
          on: {
            click: function ($event) {
              return _vm.$router.push("/dash/posts2")
            },
          },
        }),
        _c("div", { staticClass: "text" }, [
          _c("h2", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
          !_vm.previewMode.active &&
          ["create", "duplicate"].includes(_vm.mode) &&
          _vm.canRestoreDraft
            ? _c(
                "p",
                {
                  staticClass: "switchOldVersion",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("retoreDraftInLocalStorage")
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("dash.post-creator.action.restore-draft"))
                  ),
                ]
              )
            : _vm.mode !== "create"
            ? _c(
                "p",
                {
                  staticClass: "switchOldVersion",
                  on: {
                    click: function ($event) {
                      return _vm.$router.push("/dash/posts2")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("dash.post-creator.back-to-planner")))]
              )
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "btns-action" },
        [
          !_vm.previewMode.active
            ? [
                _vm.formData.planifiedDate.date
                  ? [
                      _vm.isCurrentUserAssigned
                        ? _c(
                            "div",
                            {
                              staticClass: "btn assign",
                              on: { click: _vm.unassignCurrentUser },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t("dash.post-creator.user.unassign")
                                  ) +
                                  "\n                        "
                              ),
                              _c("i", {
                                staticClass: "fa-solid fa-user-minus",
                              }),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "btn assign",
                              on: { click: _vm.assignUsers },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t("dash.post-creator.user.assign")
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.idUsersAssigned.length
                                      ? `(${_vm.idUsersAssigned.length})`
                                      : ""
                                  ) +
                                  "\n                    "
                              ),
                              _c("i", { staticClass: "fa-solid fa-user-plus" }),
                            ]
                          ),
                    ]
                  : _vm._e(),
                _c(
                  "Tooltip",
                  {
                    attrs: {
                      text: _vm.$t("dash.post-creator.media.uploading"),
                      active: _vm.isFileUploading,
                      position: "bottom",
                    },
                  },
                  [
                    _vm.mode !== "update" &&
                    !(
                      _vm.formData.planifiedDate.date &&
                      _vm.idUsersAssigned.length &&
                      _vm.requiredValidation
                    )
                      ? _c(
                          "div",
                          {
                            staticClass: "btn-outline-primary",
                            class: { disable: _vm.isFileUploading },
                            on: { click: _vm.saveDraft },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                {
                                  create: _vm.$t(
                                    "dash.post-creator.action.save-draft"
                                  ),
                                  duplicate: _vm.$t(
                                    "dash.post-creator.action.save-draft"
                                  ),
                                  edit: _vm.$t(
                                    "dash.post-creator.action.convert-to-draft"
                                  ),
                                  draft: _vm.$t(
                                    "dash.post-creator.action.save"
                                  ),
                                }[_vm.mode || "create"]
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _c(
                  "Tooltip",
                  {
                    attrs: {
                      text: _vm.$t("dash.post-creator.media.uploading"),
                      active: _vm.isFileUploading,
                      position: "bottom",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "btn-secondary icon-r",
                        class: {
                          disable:
                            _vm.isFileUploading ||
                            !_vm.pagesValidForPreview.length,
                        },
                        on: {
                          click: () => _vm.handlerChangePreviewDisplay(true),
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.textSwitchPreview) +
                            "\n                        "
                        ),
                        _c("i", { staticClass: "fa-solid fa-arrow-right" }),
                      ]
                    ),
                  ]
                ),
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass: "btn-outline-primary",
                    on: { click: () => _vm.handlerChangePreviewDisplay(false) },
                  },
                  [_vm._v(_vm._s(_vm.$t("dash.button.go_back")))]
                ),
                _c(
                  "div",
                  {
                    staticClass: "btn-secondary icon-r",
                    class: {
                      disable:
                        _vm.isFileUploading || !_vm.pagesValidForPreview.length,
                    },
                    on: { click: _vm.sendPostAllPost },
                  },
                  [
                    _vm._v(_vm._s(_vm.textBtnFinish)),
                    _c("i", { staticClass: "fa-solid fa-arrow-right" }),
                  ]
                ),
              ],
        ],
        2
      ),
    ]),
    _c("div", { ref: "postCreator", class: "post-creator " + _vm.formShow }, [
      _vm.formShow == "formMultiple"
        ? _c("div", { staticClass: "container-form" }, [
            _c("div", { staticClass: "nav-type-post" }, [
              _c(
                "div",
                {
                  staticClass: "icon-l",
                  class: { ["btn-primary"]: _vm.tab == "story" },
                },
                [
                  _c("i", { staticClass: "fa-solid fa-camera-retro" }),
                  _vm._v("Story"),
                ]
              ),
            ]),
            _c("div", { staticClass: "container-form-scroll hide-scrollbar" }, [
              _c(
                "div",
                { staticClass: "form" },
                [
                  _c(
                    "div",
                    { staticClass: "list-pages-selected hide-scrollbar" },
                    [
                      _vm.tab == "story" && !_vm.draftInstance.pages.length
                        ? _c(
                            "div",
                            {
                              staticClass: "btn-add-page",
                              on: { click: _vm.openSelectPage },
                            },
                            [
                              _c("i", { staticClass: "fa-solid fa-plus" }),
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.$t("dash.post-creator.pages.add"))
                                ),
                              ]),
                            ]
                          )
                        : [
                            _vm.draftInstance.pages.length > 1
                              ? _c(
                                  "div",
                                  { staticClass: "btn-all-container" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          "btn-all",
                                          "unselectable-all",
                                          {
                                            checked:
                                              _vm.draftInstance.form.merge
                                                .target == "main",
                                          },
                                        ],
                                        on: {
                                          click: () =>
                                            _vm.draftInstance.form.merge.run(
                                              "main"
                                            ),
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-solid fa-users",
                                        }),
                                        _c("p", [_vm._v("Tous")]),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "container-list-avatars hide-scrollbar",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "list-avatars hide-scrollbar",
                                  },
                                  _vm._l(
                                    _vm.draftInstance.pages,
                                    function (page) {
                                      return _c(
                                        "Tooltip",
                                        {
                                          key: page.id,
                                          attrs: { text: page.name },
                                        },
                                        [
                                          _c("Avatar", {
                                            attrs: {
                                              urlPicture: page.avatar,
                                              typeNetwork: page.network,
                                              checked:
                                                _vm.draftInstance.form.merge
                                                  .target.id &&
                                                _vm.draftInstance.form.merge
                                                  .target.id == page.id,
                                              edited:
                                                !!_vm.draftInstance.form.merge
                                                  .saveAllFormData.pages[
                                                  page.id
                                                ],
                                            },
                                            on: {
                                              click: () =>
                                                _vm.draftInstance.form.merge.run(
                                                  page
                                                ),
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ]
                            ),
                          ],
                    ],
                    2
                  ),
                  _c("FormStory", {
                    attrs: {
                      formData: _vm.formData,
                      updateFormData:
                        _vm.pagesSelected.length > 1 &&
                        _vm.idPageSelected &&
                        _vm.saveAllFormData.pages[_vm.idPageSelected] &&
                        _vm.saveAllFormData.main.storification[
                          _vm.idStorySelected
                        ]
                          ? _vm.saveAllFormData.pages[_vm.idPageSelected]
                          : {},
                      idStorySelected: _vm.idStorySelected,
                      files: _vm.files,
                      tab: _vm.tab,
                      formInstance: _vm.draftInstance.form,
                      storySelected: _vm.storySelected,
                    },
                    on: {
                      addFile: (...args) => this.$emit("addFile", ...args),
                    },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { ref: "containerPhone", staticClass: "container-phone" },
        [
          _vm.tab !== "story_share"
            ? _c("div", { class: `nav-stories left` }, [
                _c(
                  "div",
                  { staticClass: "list-stories" },
                  [
                    _c(
                      "draggable",
                      {
                        ref: "listMedia",
                        staticClass: "list-stories-draggable",
                        attrs: {
                          animation: 200,
                          group: "description",
                          disabled: false,
                          ",": "",
                          ghostClass: "ghost",
                          filter: ".lockdrag",
                        },
                        on: { change: _vm.moveStory },
                        model: {
                          value: _vm.draftInstance.form.stories.items,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.draftInstance.form.stories,
                              "items",
                              $$v
                            )
                          },
                          expression: "draftInstance.form.stories.items",
                        },
                      },
                      [
                        _c(
                          "transition-group",
                          { attrs: { type: "transition", name: "flip-list" } },
                          _vm._l(
                            _vm.draftInstance.form.stories,
                            function (story, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "item",
                                  class: {
                                    active: index == _vm.indexStorySelected,
                                    disable: story.hide,
                                    lockdrag: _vm.indexStorySelected !== index,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectStory(index)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(index + 1) +
                                      "\n                                "
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ],
                      1
                    ),
                    _vm.draftInstance.form.stories.length < 10 &&
                    !_vm.previewMode.active
                      ? _c(
                          "div",
                          {
                            staticClass: "item",
                            on: { click: _vm.addNewStory },
                          },
                          [_c("i", { staticClass: "fa-solid fa-plus" })]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.previewMode.active && _vm.tab == "story_share"
            ? _c("div", { staticClass: "switch-preview-post-type" }, [
                _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return (() => _vm.$emit("changeTab", "standard")).apply(
                          null,
                          arguments
                        )
                      },
                    },
                  },
                  [_vm._v("Standard")]
                ),
                _c("div", { staticClass: "btn-primary" }, [_vm._v("Story")]),
              ])
            : _vm._e(),
          _c(
            "Phone",
            { attrs: { firstPlan: _vm.phoneIsFirstPlan, showNotch: false } },
            [
              _c("StoryMaker", {
                attrs: {
                  formData: _vm.formData,
                  saveAllFormData: _vm.saveAllFormData,
                  idStorySelected: _vm.idStorySelected,
                  deleteStory: _vm.deleteStory,
                  pageSelected: _vm.previewMode.active
                    ? _vm.previewMode.pageSelected
                    : _vm.pagesSelected.find((p) => p.id == _vm.idPageSelected),
                  previewEnabled: _vm.previewMode.active,
                  files: _vm.files,
                  storySelected: _vm.storySelected,
                  formInstance: _vm.draftInstance.form,
                },
              }),
              _vm.modes.includes("addMentionMode")
                ? _c("selectMention", {
                    attrs: {
                      position: "left",
                      mentionData:
                        _vm.dataMode.addMentionMode &&
                        _vm.dataMode.addMentionMode.mention
                          ? _vm.dataMode.addMentionMode.mention
                          : {},
                      idMention:
                        _vm.dataMode.addMentionMode &&
                        _vm.dataMode.addMentionMode.idMention
                          ? _vm.dataMode.addMentionMode.idMention
                          : null,
                    },
                    on: { close: _vm.removeMode },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.previewMode.active
            ? [
                _vm.tab == "story_share"
                  ? _c("div", { staticClass: "nav-page-standard" }, [
                      _c(
                        "div",
                        { staticClass: "list-page hide-scrollbar" },
                        [
                          _vm._l(
                            _vm.listNetworkSort,
                            function (networkName, index) {
                              return [
                                _vm.pagesSelected.some(
                                  (p) => p.network == networkName
                                )
                                  ? _c(
                                      "div",
                                      {
                                        key: networkName,
                                        staticClass: "group",
                                        class: { active: false },
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "network",
                                          class: {
                                            [networkName]: true,
                                            edited:
                                              _vm.saveAllFormData.networks[
                                                networkName
                                              ] &&
                                              Object.keys(
                                                _vm.saveAllFormData.networks[
                                                  networkName
                                                ]
                                              ).length > 0,
                                            failed:
                                              _vm.previewMode.active &&
                                              _vm.pagesSelected.some(
                                                (page) =>
                                                  page.network == networkName &&
                                                  _vm.dataFormRequest[
                                                    page.id
                                                  ] &&
                                                  _vm.dataFormRequest[page.id]
                                                    .error
                                              ),
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "list-avatar" },
                                          _vm._l(
                                            _vm.pagesSelected.filter(
                                              (p) => p.network == networkName
                                            ),
                                            function (page) {
                                              return _c(
                                                "div",
                                                {
                                                  key: page.id,
                                                  staticClass:
                                                    "container-avatar",
                                                  class: {
                                                    checked:
                                                      _vm.previewMode
                                                        .pageSelected &&
                                                      _vm.previewMode
                                                        .pageSelected.id ==
                                                        page.id,
                                                  },
                                                },
                                                [
                                                  _c("Avatar", {
                                                    attrs: {
                                                      checkIsPossible: true,
                                                      checked:
                                                        _vm.previewMode
                                                          .pageSelected &&
                                                        _vm.previewMode
                                                          .pageSelected.id ==
                                                          page.id,
                                                      urlPicture: page.avatar,
                                                    },
                                                    on: {
                                                      click: () => {
                                                        _vm.$emit(
                                                          "changePreviewDisplay",
                                                          true,
                                                          page
                                                        )
                                                        _vm.$emit(
                                                          "generateFormData",
                                                          page
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                    ])
                  : _c(
                      "div",
                      { staticClass: "nav-page-story hide-scrollbar" },
                      _vm._l(_vm.pagesValidForPreview, function (page, index) {
                        return _c("Avatar", {
                          key: page.id + index,
                          attrs: {
                            urlPicture: page.avatar,
                            typeNetwork: page.network,
                            checked:
                              _vm.previewMode.pageSelected &&
                              page.id == _vm.previewMode.pageSelected.id,
                          },
                          on: {
                            click: () => {
                              _vm.$emit("changePreviewDisplay", true, page)
                              _vm.$emit("generateFormData", page)
                            },
                          },
                        })
                      }),
                      1
                    ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }